import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { CommonEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class CommonSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    commonCreated$() {
        return this.socketService.receiveMessageObserver(CommonEvents.COMMON_CREATED);
    }

    commonUpdated$() {
        return this.socketService.receiveMessageObserver(CommonEvents.COMMON_UPDATED);
    }

    commonDeleted$() {
        return this.socketService.receiveMessageObserver(CommonEvents.COMMON_DELETED);
    }
}
